import base64url from "base64url";
import aesjs from "aes-js";

var keyBytes = aesjs.utils.utf8.toBytes("cRfUjXn2r5u7x!A%D*G-KaPdSgVkYp3s");
var ivBytes = aesjs.utils.utf8.toBytes("NdRfUjXn2r5u8x/A");

export const formatViewers = (viewers) => {
  return Math.abs(viewers) > 999
    ? Math.sign(viewers) * (Math.abs(viewers) / 1000).toFixed(1) + "k"
    : Math.sign(viewers) * Math.abs(viewers);
};

export const getElapsedTime = (from, to) => {
  var elapsed = (from - to) / 1000;

  if (elapsed >= 0) {
    const diff = {};
    diff.hours = "00";
    diff.minutes = "00";
    diff.seconds = "00";

    if (elapsed >= 3600) {
      diff.hours = Math.floor(elapsed / 3600);
      elapsed -= diff.hours * 3600;
      if (diff.hours < 10) {
        diff.hours = `0${diff.hours}`;
      }
    }

    if (elapsed >= 60) {
      diff.minutes = Math.floor(elapsed / 60);
      elapsed -= diff.minutes * 60;
      if (diff.minutes < 10) {
        diff.minutes = `0${diff.minutes}`;
      }
    }
    diff.seconds = Math.floor(elapsed);

    if (diff.seconds < 10) {
      diff.seconds = `0${diff.seconds}`;
    }

    let message = `${diff.hours}:${diff.minutes}:${diff.seconds}`;
    return message;
  }
  return "00:00:00";
};

export const decrypt = (encrypted) => {
  var aesCbc = new aesjs.ModeOfOperation.cbc(keyBytes, ivBytes);
  var encryptedBytes = base64url.toBuffer(encrypted);
  var decryptedBytes = aesCbc.decrypt(encryptedBytes);
  return aesjs.utils.utf8.fromBytes(decryptedBytes);
};
